/*  ==========================================================================
    ROUTE PLANNER
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initRoutePlanner($element) {

    // initialize route planner
    let $mapContainer = $element.find('.bn-google-maps__map');
    utils.maps.initRoutePlanner($mapContainer);

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/route-planner.js